/**
 * 运单号拆分 / 比对（部分运单未查到）。
 *
 * 拆分规则与后端 EsOrderFilterBuilder.applyTrackingNumbersFilter 对齐（分号、逗号、换行），另外兼容空格；
 * 长度为 6 的 token 后端按「运单号后 6 位」匹配，这里同样按尾号比对。比对大小写不敏感。
 */
export const TRACKING_LAST_N_LENGTH = 6;

/** 补查命中运单号的单页上限（后端 MAX_PAGE_SIZE），输入超过该数量时不做 R7 提示 */
export const MAX_TRACKING_HIT_QUERY_SIZE = 200;

export function splitTrackingNumbers(raw: string | null | undefined): string[] {
    if (!raw) {
        return [];
    }
    const seen = new Set<string>();
    const result: string[] = [];
    raw.split(/[;,\s]+/).forEach((token) => {
        const value = token.trim();
        const key = value.toUpperCase();
        if (value && !seen.has(key)) {
            seen.add(key);
            result.push(value);
        }
    });
    return result;
}

export const hasLastNToken = (inputs: string[]): boolean => inputs.some((v) => v.length === TRACKING_LAST_N_LENGTH);

/** 输入中未出现在命中结果里的运单号（保持输入顺序与原始大小写） */
export function findMissingTrackingNumbers(inputs: string[], hitTrackingNumbers: Array<string | null | undefined>): string[] {
    const hits = hitTrackingNumbers.filter((v): v is string => !!v).map((v) => v.toUpperCase());
    const hitSet = new Set(hits);
    return inputs.filter((input) => {
        const key = input.toUpperCase();
        if (hitSet.has(key)) {
            return false;
        }
        if (key.length === TRACKING_LAST_N_LENGTH) {
            return !hits.some((hit) => hit.endsWith(key));
        }
        return true;
    });
}
